module.exports = __webpack_public_path__ + "img/sd.a0205062.png";